module.exports = __webpack_public_path__ + "img/ambird.54cdc29.png";